/**
 * 1.81.7 · Servidor local: pedir la actualización ya (sin esperar los 30 minutos). La usa el puesto cuando
 * el servidor tiene una versión más nueva, y el servidor cuando se le conecta un puesto más nuevo.
 * El actualizador la busca en el momento, la descarga y la instala apenas no hay una venta en curso.
 */
export const UPDATE_NOW = "sofia:update-now";
let last = 0;
export function requestUpdateNow(reason: string) {
  // Como mucho una vez por minuto (los puestos reintentan seguido).
  if (Date.now() - last < 60_000) return;
  last = Date.now();
  window.dispatchEvent(new CustomEvent(UPDATE_NOW, { detail: reason }));
}

/**
 * Grupo de la actualización escalonada: el servidor del local y sus puestos usan la misma clave (el id del
 * servidor), así reciben la versión nueva todos juntos. Los demás equipos, su propia huella.
 */
export function lanRolloutKey(raw: string | null = readLan()): string | null {
  try {
    const c = JSON.parse(raw ?? "null") as { role?: string; serverId?: string; server?: { id?: string } | null } | null;
    if (c?.role === "server" && c.serverId) return `lan:${c.serverId}`;
    if (c?.role === "puesto" && c.server?.id) return `lan:${c.server.id}`;
  } catch { /* sin almacenamiento */ }
  return null;
}

function readLan(): string | null {
  try { return localStorage.getItem("sofia.lan"); } catch { return null; }
}
